// Mållista (kill-chain): levende oversikt over ildmål med prioritet (TST/HPT),
// status-fremdrift og klikk-til-kart. Docked flytende panel i GNÅ-stil. Ren DOM
// (all felt-tekst via textContent). Sortert TST → HPT → prioritert → rutine.
import {
  sortFireTargets, nextFireStatus, FIRE_TARGET_PRIORITY_LABEL, FIRE_STATUS_LABEL,
  type FireTarget, type FireTargetPriority,
} from '@skade/contracts';

const PRIO_COLOR: Record<FireTargetPriority, string> = {
  tst: '#ff3b3b', hpt: '#ff9a3b', priority: '#ffd24a', routine: '#8fb0c8',
};

export interface TargetListHooks {
  getTargets: () => FireTarget[];
  onFocus: (t: FireTarget) => void;
  onAdvance: (id: string) => void;
  onRemove: (id: string) => void;
}

export class TargetListPanel {
  readonly el: HTMLElement;
  private open = false;
  private listEl!: HTMLElement;

  constructor(private hooks: TargetListHooks) {
    this.el = this.build();
    this.render();
  }

  toggle() { this.open = !this.open; this.el.classList.toggle('open', this.open); if (this.open) this.render(); }

  private build(): HTMLElement {
    const p = div('report-composer targetlist-panel');
    const head = div('report-head');
    head.append(span('report-title', 'Mållista (kill-chain)'));
    const x = document.createElement('button');
    x.className = 'report-x'; x.textContent = '×'; x.onclick = () => this.toggle();
    head.append(x);
    p.append(head);
    this.listEl = div('targetlist-list');
    p.append(this.listEl);
    return p;
  }

  render() {
    const items = sortFireTargets(this.hooks.getTargets());
    this.listEl.innerHTML = '';
    if (!items.length) { this.listEl.append(span('checklist-note', 'Ingen mål ennå. Legg til via «Ildstøtte».')); return; }
    for (const t of items) {
      const row = div('targetlist-row');
      const dot = document.createElement('span');
      dot.className = 'checklist-dot'; dot.style.background = PRIO_COLOR[t.priority];
      dot.title = FIRE_TARGET_PRIORITY_LABEL[t.priority];
      const main = div('checklist-main');
      const title = span('checklist-item-title', `${t.number} · ${t.desc}`);
      title.style.cursor = 'pointer';
      title.onclick = () => this.hooks.onFocus(t);
      main.append(title, span('checklist-note', `${FIRE_TARGET_PRIORITY_LABEL[t.priority]} · ${FIRE_STATUS_LABEL[t.status]}`));
      const actions = div('targetlist-actions');
      const next = nextFireStatus(t.status);
      if (next) {
        const adv = btn(`→ ${FIRE_STATUS_LABEL[next]}`, () => this.hooks.onAdvance(t.id));
        actions.append(adv);
      }
      actions.append(btn('✕', () => this.hooks.onRemove(t.id)));
      row.append(dot, main, actions);
      this.listEl.append(row);
    }
  }
}

function div(cls: string): HTMLElement { const e = document.createElement('div'); e.className = cls; return e; }
function span(cls: string, text: string): HTMLElement { const e = document.createElement('span'); e.className = cls; e.textContent = text; return e; }
function btn(text: string, run: () => void): HTMLButtonElement {
  const b = document.createElement('button');
  b.className = 'targetlist-btn'; b.textContent = text; b.onclick = run;
  return b;
}
